export class ErrorInfoHandleStrategy {
    constructor({ handler }) {
        this._handler = handler;
    }

    /**
     *
     * @type {Console | console}
     */
    logger = console;

    /**
     *
     * @private
     * @return {ErrorInfo | null}
     * @param errorInfo
     */
    _handler = (errorInfo) => errorInfo;

    /**
     *
     * @param {import('./types').ErrorInfo} errorInfo
     * @return {import('./types').ErrorInfo} errorInfo
     */
    handle(errorInfo) {
        return this._handler.call(this, errorInfo);
    }
}

export const createErrorInfoHandleStrategy = ({ handler }) => new ErrorInfoHandleStrategy({ handler });
